import React from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import {
  MobileMenuPanel,
  MobileNavButton,
  MobileNavItem,
  MobileNavLinks,
} from "./Styles";

import { navigation, NavItem } from "./NavigationData";

interface MobileNavigationProps {
  open: boolean;
  onClose: () => void;
}

export const MobileNavigation = ({
  open,
  onClose,
}: MobileNavigationProps) => {
  const [activeItem, setActiveItem] =
    React.useState<NavItem | null>(null);

  if (!open) {
    return null;
  }

const navigateTo = (item: NavItem) => {
  if (item.children) {
    setActiveItem(item);
    return;
  }

  if (item.href) {
    onClose();
  }
};

  const handleBack = () => {
    setActiveItem(null);
  };

  const items = activeItem?.children ?? navigation;

  return (
    <MobileMenuPanel>
      <MobileNavLinks>
        {activeItem && (
          <MobileNavItem>
            <MobileNavButton onClick={handleBack} data-test="mobileNavBack">
              <AiOutlineArrowLeft
                size={20}
                style={{ marginRight: "8px" }}
              />
              Back
            </MobileNavButton>
          </MobileNavItem>
        )}

        {items.map((item) => (
          <MobileNavItem key={item.label} data-test="mobileNavLabel">
            <MobileNavButton onClick={() => navigateTo(item)} data-test="mobileNavButton">
              {item.label}
            </MobileNavButton>
          </MobileNavItem>
        ))}
      </MobileNavLinks>
    </MobileMenuPanel>
  );
};